module.exports = __webpack_public_path__ + "static/media/7.49f5bf7e.svg";